import { Dialog } from "@material-ui/core";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";

const MaskingDialog = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const handleConfirmation = async () => {
    localStorage.setItem("landCoverMaskedDilog", "shown");
    setOpen(false);
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth>
      <Stack p={3}>
        <DialogTitle>
          <b>Land Cover Mask enabled</b>
        </DialogTitle>
        <DialogContent>
          <Stack gap={2}>
            <Typography>
              Subsequent drought indices and financial analysis are computed
              using data within the masked land-cover zones.
              <br />
              Disable the mask to return to full-area results.
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleConfirmation}>
            OK, got it
          </Button>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};

export default MaskingDialog;
